<template>
  <div class="infoList">
    <nav-bar title="设置支付密码"></nav-bar>
    <div class="info">
      <p>您的密码已经找回注意保密不要让其他人知道让其他人知让其他人知</p>
      <div class="bottom">
        <span>活动类型或者系统消息</span>
        <span>2月26日 15:38</span>
      </div>
    </div>
    <div class="info">
      <p>您的密码已经找回注意保密不要让其他人知道让其他人知让其他人知</p>
      <div class="bottom">
        <span>活动类型或者系统消息</span>
        <span>2月26日 15:38</span>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
export default {
  name: "infoList",
  components: {
    NavBar
  }
};
</script>

<style scoped lang="less">
.infoList {
  width: 100%;
  height: 100%;

  .info {
    width: 375px;
    height: 74px;
    background: rgba(255, 255, 255, 1);
    padding: 15px;

    p {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 37, 41, 1);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin: 6px 0;
    }

    .bottom {
      display: flex;
      justify-content: space-between;

      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(158, 160, 165, 1);
      }
    }
  }
}
</style>
